"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
function FormLimit(_a) {
    var type = _a.type;
    return react_1.default.createElement("div", { className: 'storybook-notifications-centered' },
        react_1.default.createElement(storybook_1.Notifications.Notification, { open: true, type: 'warning', title: "Je hebt het maximaal aantal " + type + " livestreams bereikt voor jouw kanaal.", description: 'neem contact op met info@eyecons.com voor een upgrade.', appendClassname: 'w-full' }));
}
exports.default = FormLimit;
